import React, { Component } from 'react';
import './SideMenu.css'
import {
    Row, Col, Collapse, Button, CardBody, Card,
} from 'reactstrap'
import driver from '../../../assets/Images/driver.jpg'
import String from '../../../assets/Locales/teacher_locales'
import { reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from "axios";
import { API_ENDPOINT } from '../../../AppConfig';
import { LoginRequest } from '../../../redux/Action/Auth/LoginAction'
import { NavsAR, NavsEN } from './routesSideMenu'
import { commonAR, commonEN } from './routesCommon'
import { Link, Redirect } from 'react-router-dom';
import { sendLogout } from '../../../redux/Action/Auth/LoginAction'
import { ActivateLevel } from '../../../redux/Action/Teacher/levelsAction'
import { closeMenu, closeMenuMobile } from '../../../redux/Action/Auth/LoginAction'
import { hideLoading, showLoading } from 'react-redux-loading-bar';
class SideMenu extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.togglemenu = this.togglemenu.bind(this);
        this.tosetTextitemggle = this.setTextitem.bind(this);
        this.state = {
            toggle: false,
            collapsemenu: false,
            textItem: "",
            studentAr: [],
            studentEN: [],
            teacherAr: [],
            teacherEn: [],
            assistantAr: [],
            assistantEn: [],
            parentAr: [],
            parentEN: [],
            prevLang: this.props.lang,
            Secondtoggle: false,
            Secondcollapsemenu: false,
            SecondtextItem: "",
            getRules: false,
            options: [{ view: false, edite: false, delete: false, add: false }],
        };
    }

    sendLogout = () => {
        this.props.sendLogout();
    }

    togglemenu() {
        this.setState(state => ({ collapsemenu: !state.collapsemenu }))
    }

    setTextitem(text) {
        this.setState({ textItem: text })
    }
    closeMenu = () => {
        this.props.closeMenu(false)
        this.props.closeMenuMobile(false)
    }
    toggle() {
        this.setState(state => ({ toggle: !state.toggle }));
    }
    toggleSecondmenu() {
        this.setState(state => ({ Secondcollapsemenu: !state.Secondcollapsemenu }))
    }

    setSecondTextitem(text) {
        this.setState({ SecondtextItem: text })
    }

    toggleSecond() {
        this.setState(state => ({ Secondtoggle: !state.Secondtoggle }));
    }
    componentWillMount() {
        this.GetSideNav()
        if (this.props.Rules.length > 0 && !this.state.getRules) {
            let rule = this.props.Rules.filter(val => this.props.lang === "ar" ? val.rule.name.ar === "تسجيل الحضور" : val.rule.name.en === "Attendance")
            if (rule.length > 0) {
                let showRule = rule[0].properties.filter(rule => rule === 'SHOW')
                let EditRule = rule[0].properties.filter(rule => rule === 'UPDATE')
                let DeleteRule = rule[0].properties.filter(rule => rule === 'DELETE')
                let AddRule = rule[0].properties.filter(rule => rule === 'ADD')
                showRule = showRule.length > 0 ? true : false
                EditRule = EditRule.length > 0 ? true : false
                DeleteRule = DeleteRule.length > 0 ? true : false
                AddRule = AddRule.length > 0 ? true : false
                this.setState({
                    options: [{ view: showRule, edite: EditRule, delete: DeleteRule, add: AddRule }],
                    getRules: true
                })
            } else {
                this.setState({
                    options: [{ view: false, edite: false, delete: false, add: false }],
                    getRules: true
                })
            }
        }
    }
    JoinVisitor = () => {
        this.setState({ redirect: true })
    }
    GetSideNav() {
        let userType = this.props.userType;

        let token = this.props.userType === 'VISITOR' ? '' : `Bearer ${this.props.token}`
        let contactUSAr = { name: "اتصل بنا", url: "/contact-us" }
        let contactUSEn = { name: "Contact Us", url: "/contact-us" }
        let aboutUSAr = { name: "عن التطبيق", url: "/about-us" }
        let aboutUSEn = { name: "About Us", url: "/about-us" }

        if (userType === 'TEACHER') {
            let uri = `${API_ENDPOINT}/teacherLevels?teacher=${this.props.user.id}`
            let levelAr = [], levelEn = []
            levelAr.push(NavsAR.items[0])
            levelEn.push(NavsEN.items[0])
            let levelsAr = { name: "المراحل", children: [], mutlilevel: true }
            let levelsEn = { name: "Levels", children: [], mutlilevel: true }
            axios.get(uri, {
                headers: {
                    Authorization: token,
                    'Accept-Language': this.props.lang
                }
            }).then(response => {
                let data = response.data.data
                let level = levelsAr.children
                let last = []
                let lastlevels = []
                for (let j = 0; j < data.length; j++) {
                    let childofchild = {
                        name: data[j].level.name,
                        sortKey: data[j].level.sortKey,
                        children: [],
                        id: data[j].id
                    }
                    level.push(childofchild)
                    last.push(childofchild)
                }
               
                for (let i = 0; i < level.length; i++) {
                  
                    //   last[i]===level[i].sortKey - 1
                    if(last[level[i].sortKey - 1])
                    {
                        lastlevels.push(last[level[i].sortKey - 1])
                        
                    }
                    else{
                        lastlevels.push(last[level[i].sortKey - 3])
                    }
                   
                    // console.log("levellll",last,level[i].sortKey - 3)
                }
                level = lastlevels
                console.log("levelsss",level)
               
                for (let i = 0; i < level.length; i++) {
                   
                    let url = `${API_ENDPOINT}/teacherSubLevels?teacherLevel=${level[i].id}`
                    axios.get(url, {
                        headers: {
                            "Accept-Language": this.props.lang,
                            Authorization: token
                        }
                    }).then(response => {
                        let subLevel = response.data.data
                        for (let j = 0; j < subLevel.length; j++) {
                            let child = {
                                name: subLevel[j].subLevel.name,
                                url: `/Levels/subjects/${subLevel[j].subLevel.name}`,
                                state: {
                                    levelId: subLevel[j].subLevel.id,
                                    levelName: subLevel[j].subLevel.name,
                                    teacherSubLevel: subLevel[j].id,
                                    subLevelID: subLevel[j].subLevel.id
                                }
                            }
                            level[i].children.push(child)
                        }
                    })
                }
                setTimeout(() => {
                    levelAr.push(levelsAr)
                    levelAr.push(NavsAR.items[1])
                    levelAr.push(NavsAR.items[2])
                    levelAr.push(NavsAR.items[3])
                    levelAr.push(NavsAR.items[4])
                    levelAr.push(NavsAR.items[5])
                    levelAr.push(NavsAR.items[8])
                    levelAr.push(NavsAR.items[9])
                    levelAr.push(NavsAR.items[6])
                    levelAr.push(NavsAR.items[7])
                    this.setState({ teacherAr: levelAr }, () => {
                        this.props.ActivateLevel(false)
                    })
                }, 1250)

            })
            axios.get(uri, {
                headers: {
                    Authorization: token,
                    'Accept-Language': this.props.lang
                }
            }).then(response => {
                let data = response.data.data
                let level = levelsEn.children
                let last = []
                let lastlevels = []
                for (let j = 0; j < data.length; j++) {
                    let childofchild = {
                        name: data[j].level.name,
                        sortKey: data[j].level.sortKey,
                        children: [],
                        id: data[j].id

                    }
                    level.push(childofchild)
                    last.push(childofchild)

                }
                for (let i = 0; i < level.length; i++) {
                    if(last[level[i].sortKey - 1])
                    {
                        lastlevels.push(last[level[i].sortKey - 1])
                      
                    }
                    else{
                        lastlevels.push(last[level[i].sortKey - 3])
                    }
                    //   last[i]===level[i].sortKey - 1
                    // lastlevels.push(last[level[i].sortKey - 1])
                    // lastlevels.push(last[level[i].sortKey - 3])
                }
                
                level = lastlevels
                levelsEn.children = lastlevels
                for (let i = 0; i < level.length; i++) {
                    let url = `${API_ENDPOINT}/teacherSubLevels?teacherLevel=${level[i].id}`
                    axios.get(url, {
                        headers: {
                            "Accept-Language": this.props.lang,
                            Authorization: token
                        }
                    }).then(response => {
                        let subLevel = response.data.data
                        for (let j = 0; j < subLevel.length; j++) {
                            let child = {
                                name: subLevel[j].subLevel.name,
                                url: `/Levels/subjects/${subLevel[j].subLevel.name}`,
                                state: {
                                    levelId: subLevel[j].subLevel.id,
                                    levelName: subLevel[j].subLevel.name,
                                    teacherSubLevel: subLevel[j].id,
                                    subLevelID: subLevel[j].subLevel.id
                                }
                            }
                            level[i].children.push(child)
                        }

                    })


                }
                setTimeout(() => {
                    levelEn.push(levelsEn)
                    levelEn.push(NavsEN.items[1])
                    levelEn.push(NavsEN.items[2])
                    levelEn.push(NavsEN.items[3])
                    levelEn.push(NavsEN.items[4])
                    levelEn.push(NavsEN.items[5])
                    levelEn.push(NavsEN.items[8])
                    levelEn.push(NavsEN.items[9])
                    levelEn.push(NavsEN.items[6])
                    levelEn.push(NavsEN.items[7])
                    this.setState({ teacherEn: levelEn }, () => {
                        this.props.ActivateLevel(false)
                    })
                }, 1250)
            })
        } else if (userType === 'ASSISTANT') {
            let postsAr = { name: "المنشورات", url: "/AllPosts" }
            let postsEn = { name: "Posts", url: "/AllPosts" }
            let attendanceAr = { name: "تسجيل الحضور", url: "/attendance" }
            let attendanceEn = { name: "Attendance", url: "/attendance" }
            let tabsAr = [], tabsEn = []
            let levelAr = [], levelEn = []
            let levelsAr = { name: "المراحل", children: [], mutlilevel: true }
            let levelsEn = { name: "Levels", children: [], mutlilevel: true }

            let uri = `${API_ENDPOINT}/teacherLevels?teacher=${this.props.user.teacher.id}`
            axios.get(uri, {
                headers: {
                    Authorization: token,
                    'Accept-Language': this.props.lang
                }
            }).then(response => {

                let data = response.data.data
                let level = levelsAr.children
                let last = []
                let lastlevels = []
                for (let j = 0; j < data.length; j++) {
                    let childofchild = {
                        name: data[j].level.name,
                        sortKey: data[j].level.sortKey,
                        children: [],
                        id: data[j].id
                    }
                    level.push(childofchild)
                    last.push(childofchild)
                }

                for (let i = 0; i < level.length; i++) {
                    //   last[i]===level[i].sortKey - 1
                    lastlevels.push(last[level[i].sortKey - 1])
                }
                level = lastlevels
                levelsAr.children = lastlevels
                for (let i = 0; i < level.length; i++) {
                    let url = `${API_ENDPOINT}/teacherSubLevels?teacherLevel=${level[i].id}`
                    axios.get(url, {
                        headers: {
                            "Accept-Language": this.props.lang,
                            Authorization: token
                        }
                    }).then(response => {
                        let subLevel = response.data.data
                        for (let j = 0; j < subLevel.length; j++) {
                            let child = {
                                name: subLevel[j].subLevel.name,
                                url: `/Levels/subjects/${subLevel[j].subLevel.name}`,
                                state: {
                                    levelId: subLevel[j].subLevel.id,
                                    levelName: subLevel[j].subLevel.name,
                                    teacherSubLevel: subLevel[j].id,
                                    subLevelID: subLevel[j].subLevel.id
                                }
                            }
                            level[i].children.push(child)
                        }
                    })
                }
                setTimeout(() => {
                    levelAr.push(levelsAr)
                    levelAr.push(commonAR.items[0])
                    levelAr.push(commonAR.items[1])
                    levelAr.push(contactUSAr)
                    levelAr.push(aboutUSAr)
                    levelAr.push(postsAr)
                    this.state.options[0].view && levelAr.push(attendanceAr)
                    this.setState({ assistantAr: levelAr }, () => {
                        this.props.ActivateLevel(false)
                    })
                }, 1250)

            })
            axios.get(uri, {
                headers: {
                    Authorization: token,
                    'Accept-Language': this.props.lang
                }
            }).then(response => {
                let data = response.data.data
                let level = levelsEn.children
                let last = []
                let lastlevels = []
                for (let j = 0; j < data.length; j++) {
                    let childofchild = {
                        name: data[j].level.name,
                        sortKey: data[j].level.sortKey,
                        children: [],
                        id: data[j].id

                    }
                    level.push(childofchild)
                    last.push(childofchild)

                }
                for (let i = 0; i < level.length; i++) {
                    //   last[i]===level[i].sortKey - 1
                    lastlevels.push(last[level[i].sortKey - 1])
                }
                level = lastlevels
                levelsEn.children = lastlevels
                for (let i = 0; i < level.length; i++) {
                    let url = `${API_ENDPOINT}/teacherSubLevels?teacherLevel=${level[i].id}`
                    axios.get(url, {
                        headers: {
                            "Accept-Language": this.props.lang,
                            Authorization: token
                        }
                    }).then(response => {
                        let subLevel = response.data.data
                        for (let j = 0; j < subLevel.length; j++) {
                            let child = {
                                name: subLevel[j].subLevel.name,
                                url: `/Levels/subjects/${subLevel[j].subLevel.name}`,
                                state: {
                                    levelId: subLevel[j].subLevel.id,
                                    levelName: subLevel[j].subLevel.name,
                                    teacherSubLevel: subLevel[j].id,
                                    subLevelID: subLevel[j].subLevel.id
                                }
                            }
                            level[i].children.push(child)
                        }

                    })


                }
                setTimeout(() => {
                    levelEn.push(levelsEn)
                    levelEn.push(commonEN.items[0])
                    levelEn.push(commonEN.items[1])
                    levelEn.push(postsEn)
                    levelEn.push(contactUSEn)
                    levelEn.push(aboutUSEn)
                    this.state.options[0].view && levelEn.push(attendanceEn)
                    this.setState({ assistantEn: levelEn }, () => {
                        this.props.ActivateLevel(false)
                    })
                }, 1250)
            })
        } else if (userType === 'STUDENT') {
            let studentSublevel = this.props.user
            let tabsAr = [], tabsEn = []
            let examAr = { name: "الامتحانات", url: "/Exams" }
            let examEN = { name: "Exams", url: "/Exams" }
            let postsAr = { name: "المنشورات", url: "/AllPosts" }
            let postsEn = { name: "Posts", url: "/AllPosts" }
            let uri = `${API_ENDPOINT}/groups?studentSubjects=true&student=${this.props.user.id}&studentSublevel=${studentSublevel.subLevel.id}`
            axios.get(uri, {
                headers: {
                    Authorization: token,
                    'Accept-Language': this.props.lang
                }
            }).then(response => {
                let data = response.data
                for (let i = 0; i < data.length; i++) {
                    let obj = {
                        name: data[i].name,
                        children: [
                            {
                                name: "المدرسون",
                                // url: "/Subject/Teachers"
                                url: `/Subject/Teachers/${data[i].name}}`,
                                state: {
                                    subLevel: studentSublevel.subLevel.id,
                                    subjectId: data[i].id,
                                    subject: data[i].name
                                }
                            },
                            {
                                name: "المجموعات",
                                url: `/Subject/Groups`,
                                state: {
                                    subjectName: data[i].name,
                                    subjectId: data[i].id
                                }
                            }
                        ]
                    }
                    tabsAr.push(obj)
                }
                tabsAr.push(commonAR.items[0])
                tabsAr.push(commonAR.items[1])
                tabsAr.push(examAr)
                tabsAr.push(postsAr)
                tabsAr.push(contactUSAr)
                tabsAr.push(aboutUSAr)
                this.setState({ studentAr: tabsAr })
            })
            axios.get(uri, {
                headers: {
                    Authorization: token,
                    'Accept-Language': this.props.lang
                }
            }).then(response => {
                let data = response.data
                for (let i = 0; i < data.length; i++) {
                    let obj = {
                        name: data[i].name,
                        children: [
                            {
                                name: "Teachers",
                                url: `/Subject/Teachers/${data[i].name}}`,
                                state: {
                                    subLevel: studentSublevel.subLevel.id,
                                    subjectId: data[i].id,
                                    subject: data[i].name
                                }
                            },
                            {
                                name: "Groups",
                                url: `/Subject/Groups`,
                                state: {
                                    subjectName: data[i].name,
                                    subjectId: data[i].id
                                }
                            }]
                    }
                    tabsEn.push(obj)
                }

                tabsEn.push(commonEN.items[0])
                tabsEn.push(commonEN.items[1])
                tabsEn.push(examEN)
                tabsEn.push(postsEn)
                tabsEn.push(contactUSEn)
                tabsEn.push(aboutUSEn)
                this.setState({ studentEN: tabsEn })
            })
        } else if (userType === 'VISITOR') {
            let studentSublevel = JSON.parse(localStorage.getItem("VisitorsublevelID"))
            let tabsAr = [], tabsEn = []
            let postsAr = { name: "المنشورات", url: "/AllPosts" }
            let postsEn = { name: "Posts", url: "/AllPosts" }
            let uri = `${API_ENDPOINT}/subject?subLevel=${studentSublevel}`
            axios.get(uri, {
                headers: {
                    Authorization: token,
                    'Accept-Language': this.props.lang
                }
            }).then(response => {
                let data = response.data.data
                for (let i = 0; i < data.length; i++) {
                    let obj = {
                        name: data[i].name,
                        children: [
                            {
                                name: "المدرسون",
                                url: `/Subject/Teachers/${data[i].name}}`,
                                state: {
                                    subLevel: studentSublevel,
                                    subjectId: data[i].id,
                                    subject: data[i].name
                                }
                            },

                        ]
                    }
                    tabsAr.push(obj)
                }
                tabsAr.push(postsAr)
                tabsAr.push(contactUSAr)
                tabsAr.push(aboutUSAr)
                this.setState({ studentAr: tabsAr })
            })
            axios.get(uri, {
                headers: {
                    Authorization: token,
                    'Accept-Language': this.props.lang
                }
            }).then(response => {
                this.props.hideLoading()
                let data = response.data.data
                for (let i = 0; i < data.length; i++) {
                    let obj = {
                        name: data[i].name,
                        children: [
                            {
                                name: "Teachers",
                                url: `/Subject/Teachers/${data[i].name}}`,
                                state: {
                                    subLevel: studentSublevel,
                                    subjectId: data[i].id,
                                    subject: data[i].name
                                }
                            }
                        ]
                    }
                    tabsEn.push(obj)
                }
                tabsEn.push(postsEn)
                tabsEn.push(contactUSEn)
                tabsEn.push(aboutUSEn)
                this.setState({ studentEN: tabsEn })
            })
        } else if (userType === 'GUARDIAN') {
            let tabsAr = [], tabsEn = []
            let postsAr = { name: "المنشورات", url: "/AllPosts" }
            let postsEn = { name: "Posts", url: "/AllPosts" }
            let childrensAr = { name: "الأبناء", url: "/studentsparent" }
            let childrensEn = { name: "childrens", url: "/studentsparent" }
            let activeStudentAr = { name: "", url: "/student-subjects", }
            let activeStudentEn = { name: "", url: "/student-subjects" }
            tabsAr.push(activeStudentAr)
            tabsAr.push(childrensAr)
            tabsAr.push(postsAr)
            this.setState({ parentAr: tabsAr })
            tabsEn.push(activeStudentEn)
            tabsEn.push(childrensEn)
            tabsEn.push(postsEn)
            this.setState({ parentEN: tabsEn })
        }
    }

    render() {
        if (this.props.activate) {
            this.GetSideNav()
        }
        // String.setLanguage(this.props.lang)
        let lang = this.props.lang ? this.props.lang : "ar"
        let user = this.props.user ? this.props.user : ""
        console.log("THELANGUAGE", this.props.lang , lang)
        let TabsAr = [], TabsEn = []
        String.setLanguage(this.props.lang )
        if (this.props.lang !== this.state.prevLang) {
            this.setState({ prevLang: this.props.lang })
            this.GetSideNav()
        }
        if (this.props.userType  === 'STUDENT' || this.props.userType  === 'VISITOR') {
            TabsAr = this.state.studentAr
            TabsEn = this.state.studentEN
        } else if (this.props.userType  === 'TEACHER') {
            if (this.state.teacherAr.length > 0) {
                TabsAr = this.state.teacherAr
            } if (this.state.teacherEn.length > 0) {
                TabsEn = this.state.teacherEn
            }
        } else if (this.props.userType  === 'GUARDIAN') {
            if (this.state.parentAr.length > 0) {
                TabsAr = this.state.parentAr
            } if (this.state.parentEN.length > 0) {
                TabsEn = this.state.parentEN
            }
        }

        else if (this.props.userType  === 'ASSISTANT') {
            if (this.state.assistantAr.length > 0) {
                TabsAr = this.state.assistantAr
            } if (this.state.assistantEn.length > 0) {
                TabsEn = this.state.assistantEn
            }
        }
        return (
            <div className={this.props.lang === "ar" ? "MyAccount mright" : "MyAccount mleft"} id={this.props.userType === 'TEACHER' ? "teacher" : this.props.userType === 'ASSISTANT' ? "assistant" :
                this.props.userType === 'STUDENT' ? "student" : "parent"} style={{ direction: lang === "ar" ? "rtl" : "ltr" }}>
                <Row className="text-center">
                    <Col lg="12" className="my-3">
                        {user && <img className="side-user-img" src={user.image !== "" ? API_ENDPOINT + user.image : driver} alt="AccLogo" />}
                        {this.props.userType  === "VISITOR" && <img className="side-user-img" src={driver} alt="AccLogo" />}

                    </Col>
                    <Col lg="12" className="mb-2">
                        <h4 className="titlecolor">{this.props.userType  !== "VISITOR" ? user.firstName : String.visitor}</h4>
                    </Col>
                    <Col lg="12" className="mb-3 accBTN">
                        {
                            this.props.userType  !== "VISITOR" &&
                            <Link to={{ pathname: "/MyAccount" }}>
                                <Button>{String.AccountBTN}</Button>
                            </Link>
                        }
                    </Col>
                </Row>
                <Row className="p-0 m-0 mb-5"
                    style={{ textAlign: lang === "ar" ? "right" : "left", }}>
                    {}
                    {
                        lang === "ar" ? TabsAr.map((text, index) => (
                            <div className="w-100">
                                {text.children ? text.mutlilevel ?
                                    <Col lg="12" className="headerBorder" id={this.props.userType  === 'TEACHER' ? "teacherBefore" : this.props.userType  === 'ASSISTANT' ? "assistnatBefore" : this.props.userType  === 'GUARDIAN' ? "parentBefore" : "studentBefore"}
                                        style={{ backgroundColor: this.state.textItem === text && this.state.toggle ? "#EFEFEF" : "", }}>
                                        <h5 onClick={() => {
                                            // this.closeMenu()
                                            this.toggle()
                                            this.togglemenu()
                                            this.setTextitem(text)
                                            this.props.ActivateLevel(false)
                                        }} style={{ width: "100%" }}>
                                            <Row>
                                                <Col className="fixWidthText" lg="10" md="10">{text.name}</Col>
                                                <Col className="fixWidthIcon" lg="1" md="1">
                                                    <i className={this.state.textItem === text && this.state.toggle ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                                                </Col>
                                            </Row>
                                        </h5>
                                        <Collapse isOpen={this.state.collapsemenu && text === this.state.textItem}>
                                            <Card>
                                                <CardBody id="levels-card">
                                                    <ul>
                                                        {text.children.map((child, ind) => (
                                                            <li>
                                                                <Col lg="12" className="headerBorder" id={this.props.userType  === 'TEACHER' ? "teacherBefore" : this.props.userType  === 'ASSISTANT' ? "assistnatBefore" : this.props.userType  === 'GUARDIAN' ? "parentBefore" : "studentBefore"}
                                                                    style={{ backgroundColor: this.state.SecondtextItem === child && this.state.Secondtoggle ? "#EFEFEF" : "", }}>
                                                                    <h5 onClick={() => {
                                                                        // this.closeMenu()
                                                                        this.toggleSecond()
                                                                        this.toggleSecondmenu()
                                                                        this.setSecondTextitem(child)
                                                                    }} style={{ width: "100%" }}>
                                                                        <Row>
                                                                            <Col className="fixWidthText" lg="10" md="10">{child.name}</Col>
                                                                            <Col className="fixWidthIcon" lg="1" md="1">
                                                                                <i className={this.state.SecondtextItem === child && this.state.Secondtoggle ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                                                                            </Col>
                                                                        </Row>
                                                                    </h5>
                                                                    <Collapse isOpen={this.state.Secondcollapsemenu && child === this.state.SecondtextItem}>
                                                                        <Card>
                                                                            <CardBody id="second-level-card">
                                                                                <ul>
                                                                                    {child.children.map((child, ind) => (
                                                                                        <li onClick={() => this.closeMenu()}>

                                                                                            <Link to={{ pathname: child.url, state: child.state }}> {child.name} </Link>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                            </CardBody>
                                                                        </Card>
                                                                    </Collapse>
                                                                </Col>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </CardBody>
                                            </Card>
                                        </Collapse>
                                    </Col> :
                                    <Col lg="12" className="headerBorder" id={this.props.userType  === 'TEACHER' ? "teacherBefore" : this.props.userType  === 'ASSISTANT' ? "assistnatBefore" : this.props.userType  === 'GUARDIAN' ? "parentBefore" : "studentBefore"}
                                        style={{ backgroundColor: this.state.textItem === text && this.state.toggle ? "#EFEFEF" : "", }}>
                                        <h5 onClick={() => {
                                            // this.closeMenu()
                                            this.toggle()
                                            this.togglemenu()
                                            this.setTextitem(text)
                                        }} style={{ width: "100%" }}>
                                            <Row>
                                                <Col className="fixWidthText" lg="10" md="10">{text.name}</Col>
                                                <Col className="fixWidthIcon" lg="1" md="1">
                                                    <i className={this.state.textItem === text && this.state.toggle ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                                                </Col>
                                            </Row>
                                        </h5>
                                        <Collapse isOpen={this.state.collapsemenu && text === this.state.textItem}>
                                            <Card>
                                                <CardBody>
                                                    <ul>
                                                        {text.children.map((child, ind) => (
                                                            <li onClick={() => this.closeMenu()}>
                                                                <Link to={{ pathname: child.url, state: child.state }}> {child.name} </Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </CardBody>
                                            </Card>
                                        </Collapse>
                                    </Col>
                                    :
                                    <Col lg="12" className={this.props.activStudent && text.name.length === 0 ? "active-stu-Col py-2" : "headerBorder"}>
                                        {(this.props.activStudent && text.name.length === 0) ?
                                            this.props.activStudent.status === "WAITING" ?
                                                <div className="active-stu-link" style={{ cursor: 'pointer' }} >
                                                    <img src={this.props.activStudent ? this.props.activStudent.student.image === "" ? driver : this.props.activStudent.student.image : driver}></img>
                                                    <span className="px-3">{this.props.activStudent && this.props.activStudent.student.firstName + ' ' + this.props.activStudent.student.secondName}</span>
                                                </div>
                                                : <Link className="active-stu-link" to={{ pathname: text.url }} onClick={() => {
                                                    this.closeMenu()
                                                    this.setState({ collapsemenu: false }, () => {
                                                        this.setTextitem(text)
                                                    })
                                                }}>
                                                    <img src={this.props.activStudent ? this.props.activStudent.student.image === "" ? driver : this.props.activStudent.student.image : driver}></img>
                                                    <span className="px-3">{this.props.activStudent && this.props.activStudent.student.firstName + ' ' + this.props.activStudent.student.secondName}</span>
                                                </Link> : <Link to={{ pathname: text.url }}>
                                                <h5 onClick={() => {
                                                    this.closeMenu()
                                                    this.setState({ collapsemenu: false }, () => {
                                                        this.setTextitem(text)
                                                    })
                                                }}>{text.name}</h5>
                                            </Link>
                                        }

                                    </Col>
                                }
                            </div>
                        )) : TabsEn.map((text, index) => (
                            <div className="w-100">

                                {text.children ? text.mutlilevel ?
                                    <Col lg="12" className="headerBorder" id={this.props.userType  === 'TEACHER' ? "teacherBefore" : this.props.userType  === 'ASSISTANT' ? "assistnatBefore" : this.props.userType  === 'GUARDIAN' ? "parentBefore" : "studentBefore"}
                                        style={{ backgroundColor: this.state.textItem === text && this.state.toggle ? "#EFEFEF" : "", }}>
                                        <h5 onClick={() => {
                                            // this.closeMenu()
                                            this.toggle()
                                            this.togglemenu()
                                            this.setTextitem(text)
                                            this.props.ActivateLevel(false)
                                        }} style={{ width: "100%" }}>
                                            <Row>
                                                <Col className="fixWidthText" lg="10" md="10">{text.name}</Col>
                                                <Col className="fixWidthIcon" lg="1" md="1">
                                                    <i className={this.state.textItem === text && this.state.toggle ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                                                </Col>
                                            </Row>
                                        </h5>
                                        <Collapse isOpen={this.state.collapsemenu && text === this.state.textItem}>
                                            <Card>
                                                <CardBody id="levels-card">
                                                    <ul>
                                                        {text.children.map((child, ind) => (
                                                            <li>
                                                                <Col lg="12" className="headerBorder" id={this.props.userType  === 'TEACHER' ? "teacherBefore" : this.props.userType  === 'ASSISTANT' ? "assistnatBefore" : this.props.userType  === 'GUARDIAN' ? "parentBefore" : "studentBefore"}
                                                                    style={{ backgroundColor: this.state.SecondtextItem === child && this.state.Secondtoggle ? "#EFEFEF" : "", }}>
                                                                    <h5 onClick={() => {
                                                                        // this.closeMenu()
                                                                        this.toggleSecond()
                                                                        this.toggleSecondmenu()
                                                                        this.setSecondTextitem(child)
                                                                    }} style={{ width: "100%" }}>
                                                                        <Row>
                                                                            <Col className="fixWidthText" lg="10" md="10">{child.name}</Col>
                                                                            <Col className="fixWidthIcon" lg="1" md="1">
                                                                                <i className={this.state.SecondtextItem === child && this.state.Secondtoggle ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                                                                            </Col>
                                                                        </Row>
                                                                    </h5>
                                                                    <Collapse isOpen={this.state.Secondcollapsemenu && child === this.state.SecondtextItem}>
                                                                        <Card>
                                                                            <CardBody id="second-level-card">
                                                                                <ul>
                                                                                    {child.children.map((child, ind) => (
                                                                                        <li onClick={() => this.closeMenu()}>

                                                                                            <Link to={{ pathname: child.url, state: child.state }}> {child.name} </Link>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                            </CardBody>
                                                                        </Card>
                                                                    </Collapse>
                                                                </Col>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </CardBody>
                                            </Card>
                                        </Collapse>
                                    </Col> :
                                    <Col lg="12" className="headerBorder" id={this.props.userType  === 'TEACHER' ? "teacherBefore" : this.props.userType  === 'ASSISTANT' ? "assistnatBefore" : this.props.userType  === 'GUARDIAN' ? "parentBefore" : "studentBefore"}
                                        style={{ backgroundColor: this.state.textItem === text && this.state.toggle ? "#EFEFEF" : "", }}>
                                        <h5 onClick={() => {
                                            // this.closeMenu()
                                            this.toggle()
                                            this.togglemenu()
                                            this.setTextitem(text)
                                        }} style={{ width: "100%" }}>
                                            <Row>
                                                <Col className="fixWidthText" lg="10" md="10">{text.name}</Col>
                                                <Col className="fixWidthIcon" lg="1" md="1">
                                                    <i className={this.state.textItem === text && this.state.toggle ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                                                </Col>
                                            </Row>
                                        </h5>
                                        <Collapse isOpen={this.state.collapsemenu && text === this.state.textItem}>
                                            <Card>
                                                <CardBody>
                                                    <ul>
                                                        {text.children.map((child, ind) => (
                                                            <li onClick={() => this.closeMenu()}>
                                                                <Link to={{ pathname: child.url, state: child.state }}> {child.name} </Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </CardBody>
                                            </Card>
                                        </Collapse>
                                    </Col>
                                    :
                                    <Col lg="12" className={this.props.activStudent && this.props.activStudent.student && text.name.length === 0 ? "active-stu-Col py-2" : "headerBorder"}>
                                        {
                                            text.name.length === 0 ? <Link className="active-stu-link" to={{ pathname: text.url }} onClick={() => {
                                                this.closeMenu()
                                                this.setState({ collapsemenu: false }, () => {
                                                    this.setTextitem(text)
                                                })
                                            }}>
                                                <img src={this.props.activStudent.student && this.props.activStudent.student.image ? this.props.activStudent.student.image : driver}></img>
                                                <span className="px-3">{this.props.activStudent.student && (this.props.activStudent.student.firstName + ' ' + this.props.activStudent.student.secondName)}</span>
                                            </Link> :
                                                <Link to={{ pathname: text.url }}>
                                                    <h5 onClick={() => {
                                                        this.closeMenu()
                                                        this.setState({ collapsemenu: false }, () => {
                                                            this.setTextitem(text)
                                                        })
                                                    }}>{text.name}</h5>
                                                </Link>}
                                    </Col>
                                }
                            </div>
                        ))
                    }
                    {this.props.userType!== "VISITOR" ?
                        <div className="hideLogout">
                            <Button onClick={this.sendLogout}>{String.LogoutBTN}</Button>
                        </div> :
                        <div className="hideLogout">
                            <Button onClick={this.JoinVisitor}>{String.JoinBTN}</Button>
                        </div>
                    }
                </Row>
                {this.state.redirect && <Redirect to="/registeration" />}
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        lang: state.lang.lang,
        userType: state.login.userType,
        user: state.login.user,
        activate: state.Levlel.activate,
        Rules: state.assign.assignedRules,
        closemenu: state.login.closemenu,
        activStudent: state.login.activeStudent
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        LoginRequest,
        sendLogout, ActivateLevel,
        closeMenu, closeMenuMobile , hideLoading 
    }
    , dispatch
)
export default reduxForm({
    form: 'fieldLevelValidation',

})(connect(mapStateToProps, mapDispatchToProps)(SideMenu));